export const itIT = {
  locale: "it-IT",
  socialButtonsBlockButton: "Continua con {{provider|titleize}}",
  dividerText: "oppure",
  formFieldLabel__emailAddress: "Indirizzo email",
  formFieldLabel__emailAddress_username: "Email o nome utente",
  formFieldLabel__username: "Nome utente",
  formFieldLabel__password: "Password",
  formFieldLabel__currentPassword: "Password attuale",
  formFieldLabel__newPassword: "Nuova password",
  formFieldLabel__confirmPassword: "Conferma password",
  formFieldLabel__signOutOfOtherSessions: "Esci da tutti gli altri dispositivi",
  formFieldLabel__firstName: "Nome",
  formFieldLabel__lastName: "Cognome",
  formFieldLabel__backupCode: "Codice di backup",
  formFieldInputPlaceholder__emailAddress: "Inserisci il tuo indirizzo email",
  formFieldInputPlaceholder__emailAddress_username: "Inserisci email o nome utente",
  formFieldInputPlaceholder__password: "Inserisci la password",
  formFieldInputPlaceholder__signUpPassword: "Crea una password",
  formFieldInputPlaceholder__firstName: "Nome",
  formFieldInputPlaceholder__lastName: "Cognome",
  formFieldInput__emailAddress_format: "Formato di esempio: nome@esempio.it",
  formFieldError__notMatchingPasswords: "Le password non coincidono.",
  formFieldError__matchingPasswords: "Le password coincidono.",
  formFieldError__verificationLinkExpired: "Il link di verifica è scaduto. Richiedine uno nuovo.",
  formFieldAction__forgotPassword: "Password dimenticata?",
  formFieldAction__hidePassword: "Nascondi password",
  formFieldAction__showPassword: "Mostra password",
  formFieldHintText__optional: "Facoltativo",
  formButtonPrimary: "Continua",
  formButtonPrimary__verify: "Verifica",
  signInEnterPasswordTitle: "Inserisci la password",
  backButton: "Indietro",
  footerActionLink__useAnotherMethod: "Usa un altro metodo",
  footerPageLink__help: "Aiuto",
  footerPageLink__privacy: "Privacy",
  footerPageLink__terms: "Termini",
  badge__primary: "Principale",
  badge__thisDevice: "Questo dispositivo",
  badge__unverified: "Non verificato",
  badge__you: "Tu",
  signUp: {
    start: {
      title: "Crea il tuo account",
      titleCombined: "Crea il tuo account",
      subtitle: "Benvenuto! Compila i dati per iniziare su {{applicationName}}",
      subtitleCombined: "Benvenuto! Compila i dati per iniziare su {{applicationName}}",
      actionText: "Hai già un account?",
      actionLink: "Accedi",
    },
    emailLink: {
      title: "Verifica la tua email",
      subtitle: "per continuare su {{applicationName}}",
      formTitle: "Link di verifica",
      formSubtitle: "Usa il link di verifica inviato al tuo indirizzo email",
      resendButton: "Non hai ricevuto il link? Invia di nuovo",
      verified: { title: "Registrazione completata" },
      loading: { title: "Registrazione in corso..." },
      verifiedSwitchTab: { title: "Email verificata", subtitle: "Torna alla scheda appena aperta per continuare", subtitleNewTab: "Torna alla scheda precedente per continuare" },
    },
    emailCode: {
      title: "Verifica la tua email",
      subtitle: "Inserisci il codice di verifica inviato alla tua email",
      formTitle: "Codice di verifica",
      formSubtitle: "Inserisci il codice di verifica inviato al tuo indirizzo email",
      resendButton: "Non hai ricevuto il codice? Invia di nuovo",
    },
    continue: {
      title: "Completa i dati mancanti",
      subtitle: "per continuare su {{applicationName}}",
      actionText: "Hai già un account?",
      actionLink: "Accedi",
    },
    restrictedAccess: {
      title: "Accesso limitato",
      subtitle: "Le registrazioni sono al momento disattivate.",
      actionText: "Hai già un account?",
      actionLink: "Accedi",
    },
    legalConsent: {
      continue: { title: "Termini e condizioni", subtitle: "Leggi e accetta i termini per continuare" },
      checkbox: {
        label__termsOfServiceAndPrivacyPolicy: 'Accetto i {{ termsOfServiceLink || link("Termini di servizio") }} e l\'{{ privacyPolicyLink || link("Informativa privacy") }}',
        label__onlyPrivacyPolicy: 'Accetto l\'{{ privacyPolicyLink || link("Informativa privacy") }}',
        label__onlyTermsOfService: 'Accetto i {{ termsOfServiceLink || link("Termini di servizio") }}',
      },
    },
  },
  signIn: {
    start: {
      title: "Accedi a {{applicationName}}",
      titleCombined: "Accedi a {{applicationName}}",
      subtitle: "Bentornato! Accedi per continuare",
      subtitleCombined: "Bentornato! Accedi per continuare",
      actionText: "Non hai un account?",
      actionLink: "Registrati",
      actionLink__use_email: "Usa l'email",
      actionLink__use_email_username: "Usa email o nome utente",
      actionLink__use_passkey: "Usa una passkey",
    },
    password: {
      title: "Inserisci la password",
      subtitle: "Inserisci la password associata al tuo account",
      actionLink: "Usa un altro metodo",
    },
    passwordPwned: { title: "Password compromessa" },
    passwordCompromised: { title: "Password compromessa" },
    forgotPasswordAlternativeMethods: {
      title: "Password dimenticata?",
      label__alternativeMethods: "Oppure accedi con un altro metodo",
      blockButton__resetPassword: "Reimposta la password",
    },
    forgotPassword: {
      title: "Reimposta la password",
      subtitle: "per reimpostare la password",
      subtitle_email: "Inserisci prima il codice inviato al tuo indirizzo email",
      formTitle: "Codice per reimpostare la password",
      resendButton: "Non hai ricevuto il codice? Invia di nuovo",
    },
    resetPassword: {
      title: "Imposta una nuova password",
      formButtonPrimary: "Reimposta password",
      successMessage: "La password è stata modificata. Accesso in corso...",
      requiredMessage: "Per motivi di sicurezza è necessario reimpostare la password.",
    },
    emailCode: {
      title: "Controlla la tua email",
      subtitle: "per continuare su {{applicationName}}",
      formTitle: "Codice di verifica",
      resendButton: "Non hai ricevuto il codice? Invia di nuovo",
    },
    emailLink: {
      title: "Controlla la tua email",
      subtitle: "per continuare su {{applicationName}}",
      formTitle: "Link di verifica",
      formSubtitle: "Usa il link di verifica inviato alla tua email",
      resendButton: "Non hai ricevuto il link? Invia di nuovo",
      verified: { title: "Accesso effettuato", subtitle: "Verrai reindirizzato a breve" },
      loading: { title: "Accesso in corso...", subtitle: "Verrai reindirizzato a breve" },
      expired: { title: "Il link è scaduto", subtitle: "Torna alla scheda originale per continuare" },
      failed: { title: "Il link non è valido", subtitle: "Torna alla scheda originale per continuare" },
    },
    emailCodeMfa: {
      title: "Controlla la tua email",
      subtitle: "Inserisci il codice di verifica inviato alla tua email",
      formTitle: "Codice di verifica",
      resendButton: "Non hai ricevuto il codice? Invia di nuovo",
    },
    newDeviceVerificationNotice: "Stai accedendo da un nuovo dispositivo. Per proteggere il tuo account è necessaria una verifica.",
    alternativeMethods: {
      title: "Usa un altro metodo",
      subtitle: "Problemi di accesso? Puoi usare uno di questi metodi.",
      actionLink: "Chiedi aiuto",
      actionText: "Non hai nessuno di questi?",
      blockButton__emailLink: "Invia link a {{identifier}}",
      blockButton__emailCode: "Invia codice a {{identifier}}",
      blockButton__password: "Accedi con la password",
      blockButton__passkey: "Usa la tua passkey",
      blockButton__backupCode: "Usa un codice di backup",
      getHelp: {
        title: "Chiedi aiuto",
        content: "Se hai problemi ad accedere, contattaci via email e ti aiuteremo a ripristinare l'accesso.",
        blockButton__emailSupport: "Contatta il supporto",
      },
    },
    noAvailableMethods: {
      title: "Impossibile accedere",
      subtitle: "Si è verificato un errore",
      message: "Impossibile procedere con l'accesso. Nessun metodo di autenticazione disponibile.",
    },
  },
  userButton: {
    action__manageAccount: "Gestisci account",
    action__signOut: "Esci",
    action__signOutAll: "Esci da tutti gli account",
    action__addAccount: "Aggiungi account",
    action__openUserMenu: "Apri menu utente",
    action__closeUserMenu: "Chiudi menu utente",
  },
  unstable__errors: {
    form_identifier_not_found: "Nessun account trovato con questo indirizzo email.",
    form_password_incorrect: "Password errata. Riprova o usa un altro metodo.",
    form_password_pwned: "Questa password è stata trovata in una violazione di dati. Scegline un'altra.",
    form_password_pwned__sign_in: "Questa password è stata trovata in una violazione di dati. Reimposta la password.",
    form_password_length_too_short: "La password è troppo corta.",
    form_password_validation_failed: "Password non valida.",
    form_param_format_invalid__email_address: "L'indirizzo email non è valido.",
    form_identifier_exists: "Questo identificativo è già in uso.",
    form_identifier_exists__email_address: "Questo indirizzo email è già registrato. Prova ad accedere.",
    form_code_incorrect: "Codice errato.",
    captcha_invalid: "Registrazione non riuscita per un controllo di sicurezza. Ricarica la pagina e riprova.",
    not_allowed_access: "Accesso non consentito.",
    passwordComplexity: {
      sentencePrefix: "La password deve contenere",
      minimumLength: "{{length}} o più caratteri",
      maximumLength: "meno di {{length}} caratteri",
      requireNumbers: "un numero",
      requireLowercase: "una lettera minuscola",
      requireUppercase: "una lettera maiuscola",
      requireSpecialCharacter: "un carattere speciale",
    },
    zxcvbn: {
      notEnough: "La password non è abbastanza sicura.",
      couldBeStronger: "La password funziona, ma potrebbe essere più sicura. Aggiungi altri caratteri.",
      goodPassword: "La password è sicura.",
    },
  },
};
